import { copy } from '../content/copy';
import { MironBlock } from '../components/MironBlock';
import { SectionLabel } from '../components/SectionLabel';

export function About() {
  const { about } = copy;
  return (
    <section id="about" className="bg-l-paper px-6 md:px-10 py-20 md:py-28">
      <div className="mx-auto max-w-[1120px] grid grid-cols-1 md:grid-cols-[7fr_5fr] gap-12 md:gap-16">
        <div>
          <SectionLabel>РАЗДЕЛ 05 · ОБО МНЕ</SectionLabel>
          <h2 className="font-display font-medium text-l-ink-deep text-[32px] md:text-[40px] leading-[1.15] tracking-[-0.02em] mb-8">
            {about.title}
          </h2>
          <div className="flex flex-col gap-5">
            {about.body.map((p) => (
              <p key={p} className="font-sans text-l-ink text-[17px] leading-[1.6]">
                {p}
              </p>
            ))}
          </div>
        </div>
        <div className="md:pt-20">
          <MironBlock caption={about.mironCaption} />
        </div>
      </div>
    </section>
  );
}
